<template>
  <main v-if="!loadingCategoriesData">
    <div class="main__container">
      <div class="page__header">
        <h1 class="page__title">{{ $t('categoriesPage.titleCategories') }}</h1>
      </div>
      <div class="panel">
        <div class="panel__body">
          <ul class="list">
            <li v-for="item in categoriesData.premium_categories" :key="item">
              <router-link :to="i18nRoute({ name: 'category page', params: { id: item.slug } })">
                {{ item.title }}
                <font-awesome-icon icon="angle-right" />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useRoute } from "vue-router"
import { useStore } from 'vuex';
import { i18nRoute } from '@/utils/useTranslate';

const store = useStore()
const route = useRoute()
const loadingCategoriesData = computed(() => store.state.categories.categoriesData.loading)
const categoriesData = computed(() => store.state.categories.categoriesData.data)
store.dispatch('categories/loadCategoriesData')

watch([route], () => {
  store.dispatch('categories/loadCategoriesData')
})
</script>

<style lang="scss" scoped>
.main__container {
  padding-top: rem(40);
}

.page {

  // .page__header

  &__header {}

  // .page__title

  &__title {
    font-size: rem(24);
  }
}


.list {
  margin-bottom: rem(80);

  @include media-breakpoint-down(xs) {
    margin: 0 rem(-20);
  }

  li {

    a {
      background-color: $base-gray-color;
      border-bottom: rem(1) solid $main-black-color;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: rem(15) rem(20);
      width: 100%;

      svg {
        color: $light-gray-color;
      }
    }
  }
}
</style>